import React, { Component } from 'react';
import './Content.css';

export default class Content extends Component {
	render() {
		return <div className={'g-content ' + (this.props.className || '')}>{this.props.children}</div>;
	}
}
